export enum CreditCardType {
    Visa = 'visa',
    MasterCard = 'mastercard',
    AmericanExpress = 'american_express',
    Discover = 'discover',
    Jcb = 'jcb'
}